import { LinkEntity } from "@/indexedDB/types";
import { extractDomainFavicon, extractDomainName } from "@/lib/linkExtractor";

import {
  getUrlMetadataWithQueue,
  LinkMetadataType,
} from "@/server/services/scrapeService";
import { isValidLink } from "@/lib/utils";

export const processMessageLink = async ({
  messageId,
  chatId,
  timestamp,
  link,
  withMetadata,
  signal,
}: {
  chatId: string;
  messageId: string;
  timestamp: string;
  link?: string;
  withMetadata?: boolean;
  signal?: AbortSignal;
}): Promise<LinkEntity | null> => {
  // extra check on abort controller and existing links
  if (signal?.aborted || !link || !isValidLink(link)) {
    return null;
  }

  try {
    const domainUrl = extractDomainName(link);
    const domainFavicon = extractDomainFavicon(link);

    const processedLink: LinkEntity = {
      id: messageId,
      chatId,
      timestamp,
      url: link,
      domainUrl: domainUrl || undefined,
      faviconUrl: domainFavicon || undefined,
      withMetadata: false,
    };

    if (withMetadata) {
      const linkMetadata = await getUrlMetadataWithQueue(link, chatId);
      const processedLinkWithMetadata = {
        ...processedLink,
        withMetadata: true,
        metaTitle: linkMetadata.title,
        metaDescription: linkMetadata.description,
        ogImage: linkMetadata.image,
      };
      return processedLinkWithMetadata;
    }

    return processedLink;

    // eslint-disable-next-line @typescript-eslint/no-unused-vars
  } catch (error) {
    // return [];
    return null;
  }
};

export type RtfLinkType = {
  domainUrl?: string;
  faviconUrl?: string;
} & LinkMetadataType;

export const processRtfLink = async ({
  link,
  chatId,
  signal,
}: {
  link: string;
  chatId: string;
  signal?: AbortSignal;
}): Promise<RtfLinkType | null> => {
  // extra check on abort controller and existing links
  if (signal?.aborted || !link || !isValidLink(link)) {
    return null;
  }

  try {
    const domainUrl = extractDomainName(link);
    const faviconUrl = extractDomainFavicon(link);

    const linkMetadata = await getUrlMetadataWithQueue(link, chatId);

    const processRtfLinkMetadata = {
      domainUrl: domainUrl || undefined,
      faviconUrl: faviconUrl || undefined,
      ...linkMetadata,
    };

    return processRtfLinkMetadata;

    // eslint-disable-next-line @typescript-eslint/no-unused-vars
  } catch (error) {
    return null;
  }
};
